import styled, { keyframes } from 'styled-components'
import Icon from 'components/Icon.v2'
import { VendorHeaderItemStatus } from 'pages/vendor/Mobile/VendorHeader/styled'

export const HeaderContainer = styled.div`
  color: #ffffff;
  position: relative;
  min-height: 220px;
  align-items: center;
  display: flex;
  padding-left: 40px;
  padding-right: 40px;
`

export const InfoSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  color: var(--Grey-2, #999);
  font-family: Montserrat;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px; /* 142.857% */
`

export const CoverImageContainer = styled.div`
  position: absolute;
  right: 40px;
  bottom: 0;
  width: 375px;
  height: 200px;
  border-radius: 12px 12px 0 0;
  overflow: hidden;
  `

export const VenueName = styled.div`
  color: var(--Black, #000);
  font-family: Montserrat;
  font-size: 32px;
  font-style: normal;
  font-weight: 700;
  line-height: 40px; /* 125% */
`

export const Tags = styled.div`
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  color: #666;
  text-transform: uppercase;
`

export const ActionsContainer = styled.div`
  margin-top: 20px;
  display: flex;
  gap: 16px;
`

export const Description = styled.section`
  margin-top: 15px;
  max-width: 520px;
  font-size: 13px;
  font-weight: 300;
`

export const FavouriteButton = styled.button`
  outline: none;
  display: flex;
  align-items: center;

  color: #F26722;
  text-align: center;
  font-family: Montserrat;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 20px;

  height: 40px;
  padding: 4px 16px;
  border-radius: 8px;
  background: #FDF0E9;

  &:focus {
    outline: none;
  }
`

export const FavouriteIcon = styled(Icon)`
  margin-right: 10px;
  height: 16px;
  width: 16px;
`

export const DiscountButton = styled.button`
  display: inline-flex;
  border: none;
  padding: 11px 15px;
  background: rgba(255, 255, 255, 0.2);
  color: white;
  font-size: 13px;
  font-weight: 300;
`

export const DiscountIcon = styled(Icon)`
  margin-right: 10px;
`

export const OrderPartyButton = styled.div`
  position: absolute;
  right: 20px;
  top: 20px;
`

const slideDown = keyframes`
  from {
    transform: translateY(-100%);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
`;

const slideUp = keyframes`
  from {
    transform: translateY(0);
    opacity: 1;
  }
  to {
    transform: translateY(-100%);
    opacity: 0;
  }
`;


export const VendorHeaderStatus = styled(VendorHeaderItemStatus)`
  display: block;
  position: relative;
  height: 44px;
  display: flex;
  gap: 8px;
  align-items: center;
  animation: ${props => props.$isClosing ? slideUp : slideDown} 0.5s ease-out forwards;
  & > div {
    width: 100%;
    height: 100%;
  }
`
